// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:25
import { NumberState_abstract } from './../abstract/SagaBase/NumberState_abstract';
export class NumberState extends NumberState_abstract {}
